<template>
  <v-container>
    <v-dialog v-model="dialog.zoom" scrollable persistent width="650">
      <v-card>
        <v-card-title class="primary white--text">
          <v-icon color="white" class="mr-2">mdi-information</v-icon>
          Detail Gambar
          <v-btn
            class="mt-n1"
            icon
            dark
            top
            right
            absolute
            @click.stop="
              dialog.zoom = false;
              zoom = '';
            "
          >
            <v-icon color="grey">mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="pt-6">
          <v-img :src="zoom">
            <template v-slot:placeholder>
              <v-row class="fill-height ma-0" align="center" justify="center">
                <v-progress-circular indeterminate color="grey lighten-5" />
              </v-row>
            </template>
          </v-img>
        </v-card-text>
        <v-card-actions class="pb-6 px-6">
          <v-spacer></v-spacer>
          <v-btn
            small
            color="#fff"
            elevation="0"
            class="text-capitalize grey--text text--darken-1"
            @click.stop="
              dialog.zoom = false;
              zoom = '';
            "
          >
            Tutup
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-row justify="center">
      <v-col cols="12" md="9">
        <h1 class="text-h4 mb-2">Detail Acara</h1>
        <div class="body-1 text--secondary">
          Informasi detail, seperti nama dan lokasi, data yang berkaitan
        </div>
      </v-col>
    </v-row>
    <v-row justify="center" class="my-4">
      <v-col cols="12" md="3">
        <v-card outlined>
          <v-card-text>
            <v-row dense>
              <v-col>
                <v-list-item-title
                  class="body-2 grey--text text--darken-2 mt-2"
                >
                  <p class="caption grey--text text-lighten-4 mb-1">
                    Nama
                  </p>
                  {{ event.eventName || '-' }}
                </v-list-item-title>
              </v-col>
            </v-row>
            <v-row dense>
              <v-col>
                <v-list-item-title
                  class="body-2 grey--text text--darken-2 mt-2"
                >
                  <p class="caption grey--text text-lighten-4 mb-1">
                    Tanggal
                  </p>
                  {{ event.eventDate || '-' }}
                </v-list-item-title>
              </v-col>
            </v-row>
            <v-row dense>
              <v-col>
                <p class="caption grey--text text-lighten-4 mb-1">
                  Deskripsi
                </p>
                {{ event.eventContent || '-' }}
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12" md="6">
        <v-container class="py-0">
          <v-row>
            <v-col cols="12">
              <v-card outlined>
                <v-tabs class="custom-tabs" color="light-green">
                  <v-tab class="text-capitalize">
                    Lokasi
                  </v-tab>
                </v-tabs>
                <v-card flat>
                  <v-card-text>
                    <v-img>
                      <gmap-map
                        ref="gmap"
                        :center="center"
                        :zoom="18"
                        :scrollwheel="false"
                        map-type-id="satellite"
                        style="width:100%;  height: 50vh;"
                      >
                        <gmap-marker
                          v-for="(item, index) in markers"
                          :key="index"
                          :position="item.position"
                          :icon="item.icon"
                          @click="toggleInfoWindow(item, index)"
                        >
                        </gmap-marker>

                        <gmap-info-window
                          :options="{
                            pixelOffset: {
                              width: 0,
                              height: -20
                            }
                          }"
                          :position="infoWindowPos"
                          :opened="infoWinOpen"
                          @closeclick="infoWinOpen = false"
                        >
                          <div v-html="infoContent"></div>
                        </gmap-info-window>
                      </gmap-map>
                    </v-img>
                  </v-card-text>
                </v-card>
              </v-card>
            </v-col>
            <v-col cols="12">
              <v-card outlined>
                <v-tabs class="custom-tabs" color="light-green">
                  <v-tab class="text-capitalize">
                    Lampiran
                  </v-tab>
                </v-tabs>
                <v-card flat>
                  <v-card-text>
                    <v-row dense>
                      <v-col
                        v-for="(attachment, i) in event.eventAttachment"
                        :key="`attachment-${i}`"
                      >
                        <v-card
                          width="150"
                          height="150"
                          elevation="4"
                          v-if="attachment.type === 'image'"
                          @click="
                            dialog.zoom = true;
                            zoom = attachment.url.original;
                          "
                        >
                          <v-img
                            width="150"
                            height="150"
                            :src="attachment.url.compressed"
                          >
                            <template v-slot:placeholder>
                              <v-row
                                class="fill-height ma-0"
                                align="center"
                                justify="center"
                              >
                                <v-progress-circular
                                  indeterminate
                                  color="grey lighten-5"
                                />
                              </v-row>
                            </template>
                          </v-img>
                        </v-card>
                        <v-card
                          v-else
                          class="ma-3 d-flex align-center justify-center align-content-center flex-column"
                          height="150"
                          width="150"
                          elevation="4"
                          @click="
                            downloadHandler(
                              attachment.url.original,
                              attachment.name
                            )
                          "
                        >
                          <v-img
                            width="150"
                            height="150"
                            :src="attachment.url.compressed"
                          >
                            <template v-slot:placeholder>
                              <v-row
                                class="fill-height ma-0"
                                align="center"
                                justify="center"
                              >
                                <v-progress-circular
                                  indeterminate
                                  color="grey lighten-5"
                                />
                              </v-row>
                            </template>
                          </v-img>
                        </v-card>
                      </v-col>
                      <v-col
                        cols="12"
                        v-show="
                          !loadEvent &&
                            (!event.eventAttachment ||
                              event.eventAttachment.length < 1)
                        "
                      >
                        <span class="text-center text--secondary">
                          Tidak ada lampiran
                        </span>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </v-card>
            </v-col>
          </v-row>
        </v-container>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import event from '@/mixins/event';
import map from '@/mixins/map';
export default {
  mixins: [event, map],
  data() {
    return {
      zoom: '',
      dialog: {
        zoom: false
      }
    };
  },
  async mounted() {
    const event = await this.getEvent(this.$route.params.id);
    this.insertMarker(event.eventLatitude, event.eventLongitude, event);
  },
  methods: {
    getInfoWindowContent(marker) {
      return `
          <div id="iw-container">
            <div class="iw-title">
              Posisi ${marker.content.eventName}
            </div>
            <div class="iw-content">
              Latitude: ${marker.content.eventLatitude}
              Longititude: ${marker.content.eventLongitude}
            </div>
          </div>
        `;
    }
  }
};
</script>
